module.exports = __webpack_public_path__ + "static/media/3.c9a83060.jpg";